import { useMutation } from 'react-query';
import {
  performanceReportingApiUrl,
  fetcher,
  handleError,
  createParamString,
  ServerErrorResponse,
} from 'data_sources/constants';
import type { CreateReviewWorkflowRequest, ReviewWorkflowDetail } from '../_types';

export const createReviewWorkflow = async (
  data: CreateReviewWorkflowRequest,
  organizationId?: string | null,
  onError?: (errors: ServerErrorResponse) => void
): Promise<ReviewWorkflowDetail> => {
  const baseUrl = `${performanceReportingApiUrl()}/performance/review-workflow/v1/review-workflows`;
  const queryParams = createParamString({ organizationId });
  const url = queryParams ? `${baseUrl}?${queryParams}` : baseUrl;
  try {
    const response = await fetcher({ url, method: 'POST', body: data });
    if (response?.errorDetails) {
      if (onError) onError(response);
      throw new Error(JSON.stringify(response));
    }
    return response;
  } catch (error: unknown) {
    if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
      onError(error as ServerErrorResponse);
    } else if (onError && error instanceof Error) {
      handleError(error, { onError });
    }
    throw error;
  }
};

export default function useCreateReviewWorkflow(onError?: (errors: ServerErrorResponse) => void) {
  return useMutation(
    ({ data, organizationId }: { data: CreateReviewWorkflowRequest; organizationId?: string | null }) =>
      createReviewWorkflow(data, organizationId, onError)
  );
}
